import React, { useEffect, useState } from "react";
import Layout from "../../../Components/Layout/Layout";
import DetailsTableProspect from "../../../Components/AiProfile/AddProfile/DetailsTableProspect/Index";
import DetailsFormProspect from "../../../Components/AiProfile/AddProfile/DetailsFormProspect/Index";
import NewAIProfileButton from "../../../Components/AiLeads/NewAiProfileButton/Index";
import { toast } from "react-toastify";
import axios from "axios";
import {
  APIUrlOne,
  APIUrlThree,
  APIUrlToken,
  GetUserId,
} from "../../../Utils/Utils";
import Loader from "../../../Components/Loader/Loader";
import { AI_PROFILE } from "../../../Utils/Constants";
import { useLocation, useNavigate } from "react-router-dom";

const ProspectProfile = () => {
  const location = useLocation();
  const prefilledData = location?.state?.data;
  const navigate = useNavigate();
  const [ShowAutocompleteprimary, setShowAutocompleteprimary] = useState(false);
  const [ResponseDatanew, setResponseDatanew] = useState(null);
  const [ResponseData, setResponseData] = useState(null);
  const loggedInUserId = GetUserId();
  const [loading, setLoading] = useState();
  const [tableShowResult, setTableShowResult] = useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [isFilterRetrieve, setIsFilterRetrieve] = useState([]);
  const [applyPeopleFilterData, setApplyPeopleFilterData] = useState([]);
  const [resultRetrieve, setResultRetrieve] = useState([]);
  const [decisionMakerData, setDecisionMakerData] = useState({
    primaryOrganization: "",
    decisionmaker: "",
    // primaryOrganization: "",
    // primaryJobTitle: "",
    country: "",
    state: "",
    categories: "",
    josfStatus: "",
    numEmployees: "",
    revenueRange: "",
    addedName: "",
    seniority: "",
  });
  const [hasMore, setHasMore] = React.useState(true);
  const [totalRecords, setTotalRecords] = useState("");
  const [newShowingResult, setNewShowingResult] = useState();
  const [showingResult, setShowingResult] = useState();
  const [skip, setSkip] = React.useState(0);
  const perPage = 50;
  const [totalCount, setTotalCount] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [ResponseJobData, setResponseJobData] = useState(null);
  const [ShowAutocomplete, setShowAutocomplete] = useState(false);
  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);
  const decisionmakerfilter = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/people_filters`,
    };
    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.request?.response);
        setIsFilterRetrieve(data);
      })
      .catch(() => {});
  };
  React.useEffect(() => {
    decisionmakerfilter();
  }, []);

  const validations = () => {
    if (!decisionMakerData?.categories?.length) {
      toast.error("Please Select Industry");
      return false;
    }
    return true;
  };

  // const validations = () => {
  //   if (
  //     !decisionMakerData?.primaryOrganization &&
  //     !decisionMakerData?.categories &&
  //     !decisionMakerData?.revenueRange &&
  //     !decisionMakerData?.numEmployees &&
  //     !decisionMakerData?.country &&
  //     !decisionMakerData?.state &&
  //     !decisionMakerData?.decisionmaker &&
  //     !decisionMakerData?.josfStatus
  //   ) {
  //     toast.error("Please select at least one field");
  //     return false;
  //   }
  //   return true;
  // };

  const modalvalidation = () => {
    if (!decisionMakerData?.categories) {
      toast.error("Please Select Industry");
      // toast.error("Please Enter Search Name");
      return false;
    }
    return true;
  };
  const handlesave = (e) => {
    e.preventDefault();
  };
  const handleClose = () => setModalOpen(false);
  const categoriesArr = [];
  categoriesArr.push(decisionMakerData?.categories);

  const numEmployessArr = [];
  numEmployessArr.push(decisionMakerData?.numEmployees);

  const handleModelSave = () => {
    if (!modalvalidation()) return;
    if (!decisionMakerData?.addedName) {
      toast.error("Please Enter Search Name");
      return;
    }
    setLoading(true);
    const data = {};
    data.user_id = loggedInUserId?.toString();
    data.name = decisionMakerData?.addedName;
    data.primary_organization = decisionMakerData?.primaryOrganization || null;
    data.categories = decisionMakerData?.categories
      ? [decisionMakerData?.categories]
      : null;
    data.revenue_range = decisionMakerData?.revenueRange || null;
    data.seniority = decisionMakerData?.seniority || null
    // decisionMakerData?.seniority
    //   ? [decisionMakerData?.seniority]
    //   : null;
    data.number_employees = decisionMakerData?.numEmployees || null;
    data.country = decisionMakerData?.country
      ? [decisionMakerData.country]
      : null;
    data.state = decisionMakerData?.state || null;
    data.decision_maker =
      decisionMakerData?.decisionmaker === "Yes"
        ? true
        : decisionMakerData?.decisionmaker === "No"
          ? false
          : null;
    data.josf_status =
      decisionMakerData?.josfStatus === "Available"
        ? true
        : decisionMakerData?.josfStatus === "Not Available"
          ? false
          : null;
    data.public = false;

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/add_filter_people`,
      data: JSON.stringify(data),
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        if (response?.status === 200) {
          setDecisionMakerData({
            categories: "",
            seniority: "",
            numEmployees: "",
            revenueRange: "",
            decisionmaker: "",
            primaryOrganization: "",
            sample: "",
            primaryJobTitle: "",
            sampleTwo: "",
            country: "",
            state: "",
            josfStatus: "",
            strengthScore: "",
            addedName: "",
          });
          handleClose();
          toast.success(response?.data?.message);
          navigate("/aiprofile/0", { state: 1 });
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const handleModelUpdate = () => {
    if (!modalvalidation()) return;
    setLoading(true);
    const data = {};
    data.user_id = loggedInUserId?.toString();
    data.name = prefilledData?.name;
    data.primary_organization = decisionMakerData?.primaryOrganization || null;
    data.categories = decisionMakerData?.categories
      ? [decisionMakerData?.categories]
      : null;
    data.seniority = decisionMakerData?.seniority
      ? [decisionMakerData?.seniority]
      : null;
    data.revenue_range = decisionMakerData?.revenueRange || null;
    data.number_employees = decisionMakerData?.numEmployees || null;
    data.country = decisionMakerData?.country
      ? [decisionMakerData.country]
      : null;
    data.state = decisionMakerData?.state || null;
    data.decision_maker =
      decisionMakerData?.decisionmaker === "Yes"
        ? true
        : decisionMakerData?.decisionmaker === "No"
          ? false
          : null;
    data.josf_status =
      decisionMakerData?.josfStatus === "Available"
        ? true
        : decisionMakerData?.josfStatus === "Not Available"
          ? false
          : null;
    data.public = prefilledData?.public;

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/update_filter_people`,
      data: JSON.stringify(data),
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        if (response?.status === 200) {
          setDecisionMakerData({
            categories: "",
            seniority: "",
            numEmployees: "",
            revenueRange: "",
            decisionmaker: "",
            primaryOrganization: "",
            sample: "",
            primaryJobTitle: "",
            sampleTwo: "",
            country: "",
            state: "",
            josfStatus: "",
            strengthScore: "",
            addedName: "",
          });
          handleClose();
          toast.success(response?.data?.message);
          navigate("/aiprofile/0", { state: 1 });
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const fetchMoreData = () => {
    if (!resultRetrieve?.length) return;
    const hasMore = resultRetrieve?.length < totalRecords;
    if (!hasMore) return;
    // when i need to hit pagination please uncomment line no. 633
    setSkip((prevskip) => prevskip + 50);
  };

  const toggleResult = (e) => {
    setModalOpen(false);
    if (!validations()) return;
    setLoading(true);

    const data = {
      primary_organization:
        decisionMakerData?.primaryOrganization?.split(",")[0].trim() || null,

      // primary_organization: decisionMakerData?.primaryOrganization || null,
      categories: decisionMakerData?.categories
        ? [decisionMakerData?.categories]
        : null,
      revenue_range: decisionMakerData?.revenueRange || null,
      seniority: decisionMakerData?.seniority
        ? [decisionMakerData?.seniority]
        : null,
      number_employees: decisionMakerData?.numEmployees || null,

      country: decisionMakerData?.country ? [decisionMakerData.country] : null,
      state: decisionMakerData?.state || null,
      decision_maker:
        decisionMakerData?.decisionmaker === "Yes"
          ? true
          : decisionMakerData?.decisionmaker === "No"
            ? false
            : null,
      josf_status:
        decisionMakerData?.josfStatus === "Available"
          ? true
          : decisionMakerData?.josfStatus === "Not Available"
            ? false
            : null,
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/vv1/apply_people_filter?user_id=${loggedInUserId}&limit=${perPage}&skip=${
        e == "show" ? 0 : skip ? skip * 50 : 0
      }`,
      data: JSON.stringify(data),
    };

    axios(option)
      .then((response) => {
        setLoading(false);
        const resultData = response?.data?.data || [];

        setShowingResult(resultData.length);
        setNewShowingResult(skip ? skip * 50 : 0);

        if (response?.status === 200) {
          setTotalPages(10);
          setTotalCount(response?.data?.count);

          if (resultData.length === 0) {
            setHasMore(false);
            // toast.error(
            //   "No Results For Now. Please adjust filters to view results."
            // );
            setResultRetrieve([]);
          } else {
            if (e == "show") {
              setResultRetrieve(resultData);
            } else {
              setResultRetrieve([...resultRetrieve, ...resultData]);
            }
            setTotalRecords(response?.data?.count);
            setTableShowResult(true);
            toast.success(response?.data?.message);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (resultRetrieve?.length < Number(totalCount)) {
      toggleResult();
    }
  }, [skip]);

  useEffect(() => {
    if (prefilledData?.id) {
      setDecisionMakerData({
        categories: prefilledData?.categories?.[0],
        numEmployees: prefilledData?.number_employees,
        revenueRange: prefilledData?.revenue_range,
        seniority: prefilledData?.seniority?.[0],
        decisionmaker:
          prefilledData?.decisionmaker === true
            ? "Yes"
            : prefilledData?.decisionmaker === false
              ? "No"
              : null,
        primaryOrganization: prefilledData?.primary_organization,
        primaryJobTitle: prefilledData?.primary_job_title,
        country: prefilledData?.country?.[0],
        state: prefilledData?.state,
        josfStatus:
          prefilledData?.josf_status === "true"
            ? "Available"
            : prefilledData?.josf_status === "false"
              ? "Not Available"
              : null,
        strengthScore: "",
        addedName: prefilledData?.name,
      });
      setShowAutocompleteprimary(false);
    }
  }, [prefilledData]);

  useEffect(() => {
    if (
      (decisionMakerData?.addedName ||
        decisionMakerData?.country ||
        decisionMakerData?.decisionmaker ||
        decisionMakerData?.josfStatus ||
        decisionMakerData?.primaryJobTitle ||
        decisionMakerData?.primaryOrganization ||
        decisionMakerData?.categories ||
        decisionMakerData?.seniority ||
        decisionMakerData?.numEmployees ||
        decisionMakerData?.revenueRange ||
        decisionMakerData?.state) &&
      prefilledData
    ) {
      DecisionMakerDataListing();
    }
  }, [decisionMakerData?.addedName, prefilledData]);

  const DecisionMakerDataListing = () => {
    setLoading(true);
    const data = {};
    data.user_id = loggedInUserId;
    data.name = decisionMakerData?.addedName;
    data.decision_maker =
      decisionMakerData?.decisionmaker === "Yes"
        ? true
        : decisionMakerData?.decisionmaker === "No"
          ? false
          : null;
    data.primary_organization = decisionMakerData?.primaryOrganization;
    data.categories = decisionMakerData?.categories
      ? [decisionMakerData?.categories]
      : [];
    data.number_employees = decisionMakerData?.numEmployees;
    data.revenue_range = decisionMakerData?.revenueRange;
    data.seniority = decisionMakerData?.seniority
      ? [decisionMakerData?.seniority]
      : [];
    data.country = decisionMakerData?.country
      ? [decisionMakerData?.country]
      : null;
    data.state = decisionMakerData?.state;
    data.josf_status =
      decisionMakerData?.josfStatus === "Available"
        ? true
        : decisionMakerData?.josfStatus === "Not Available"
          ? false
          : null;
    data.j_score = decisionMakerData?.strengthScore;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/apply_people_filter?user_id=${loggedInUserId}&limit=${perPage}&skip=${skip ? skip * 50 : 0}`,
      data: JSON.stringify(data),
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        if (response?.status === 200) {
          setTotalPages(10);
          setTotalCount(response?.data?.count);
          if (response?.data?.data?.length === 0) {
            setHasMore(false);
          } else {
            setTotalRecords(response?.data?.count);
            setResultRetrieve([...resultRetrieve, ...response?.data?.data]);
          }

          if (response?.data?.data?.length) {
            setTableShowResult(true);
            toast.success(response?.data?.message);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  const jobtitlesearch = (e) => {
    setLoading(true);
    const data = {};
    data.job_title = decisionMakerData.primaryJobTitle;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/job_title_search`,
      data: JSON.stringify(data),
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        setShowAutocomplete(true);
        if (response?.status === 200) {
          setResponseJobData(response.data);
          setResponseData(response.data);
          toast.success(response?.data?.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const handelselectjobtitle = (item) => {
    setShowAutocomplete(true);
    const people_name = `${
      item.primary_job_title ? item?.primary_job_title : ""
    }`;
    setDecisionMakerData({
      ...decisionMakerData,
      primaryJobTitle: people_name,
    });
    setShowAutocomplete(false);
  };

  const handelselectdata = (item) => {
    if (prefilledData?.id) {
      setShowAutocompleteprimary(false);
    } else {
      setShowAutocompleteprimary(true);
    }

    const people_name = `${item.org_name ? item?.org_name : ""}`;
    setDecisionMakerData({
      ...decisionMakerData,
      primaryOrganization: people_name,
    });
    setShowAutocompleteprimary(false);
  };
  const handlesearch = (e) => {
    setLoading(true);
    const data = {
      org_name: decisionMakerData.primaryOrganization,
    };

    axios
      .post(`${APIUrlThree()}/v1/org_search`, data, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (location?.state?.disableFields === true) {
            setShowAutocompleteprimary(false);
          } else {
            setShowAutocompleteprimary(true);
          }
          setLoading(false);
          setResponseDatanew(response.data);
          toast.success(response.data.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };

  React.useEffect(() => {
    if (!prefilledData?.id) {
      let timer;
      if (
        decisionMakerData.primaryJobTitle?.length > 2 &&
        ResponseData === null
      ) {
        timer = setTimeout(() => {
          jobtitlesearch();
        }, 1000);
      }

      if (decisionMakerData.primaryJobTitle?.length === 0) {
        setResponseData(null);
      }
      return () => clearTimeout(timer);
    }
  }, [decisionMakerData.primaryJobTitle, ResponseData]);

  React.useEffect(() => {
    if (!prefilledData?.id) {
      let timer;
      if (
        decisionMakerData.primaryOrganization?.length > 2 &&
        ResponseDatanew === null
      ) {
        timer = setTimeout(() => {
          handlesearch();
        }, 1000);
      }
      if (decisionMakerData.primaryOrganization?.length === 0) {
        setResponseDatanew(null);
      }
      return () => clearTimeout(timer);
    }
  }, [decisionMakerData, ResponseDatanew]);

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  
    const [isTabletPortrait, setIsTabletPortrait] = useState(false);
  
    useEffect(() => {
      const mediaQuery = window.matchMedia(
        "(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)",
      );
      setIsTabletPortrait(mediaQuery.matches);
      const handleChange = (e) => setIsTabletPortrait(e.matches);
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    }, []);
  

  return (
    <>
      {loading ? <Loader /> : null}
      <Layout className={"paddingSet"}>
        {isMobile ? (
          <div className="child-section-of-everypage set-tabs-ai-section">
            <div className="details-table-form-page">
              <div className="details-form-page">
                <DetailsFormProspect
                  prefilledData={prefilledData}
                  setShowAutocompleteprimary={setShowAutocompleteprimary}
                  setShowAutocomplete={setShowAutocomplete}
                  ResponseDatanew={ResponseDatanew}
                  ResponseData={ResponseData}
                  ShowAutocompleteprimary={ShowAutocompleteprimary}
                  handlesearch={handlesearch}
                  handelselectdata={handelselectdata}
                  ShowAutocomplete={ShowAutocomplete}
                  handelselectjobtitle={handelselectjobtitle}
                  jobtitlesearch={jobtitlesearch}
                  ResponseJobData={ResponseJobData}
                  handlesave={handlesave}
                  tableShowResult={tableShowResult}
                  decisionMakerData={decisionMakerData}
                  setDecisionMakerData={setDecisionMakerData}
                  setTableShowResult={setTableShowResult}
                  handleModelSave={handleModelSave}
                  toggleResult={toggleResult}
                  isFilterRetrieve={isFilterRetrieve}
                  setResultRetrieve={setResultRetrieve}
                  isMobile={isMobile}
                  handleModelUpdate={handleModelUpdate}
                />
              </div>
            </div>
          </div>
        ) : isTabletPortrait ?  (
          <div>
                <DetailsFormProspect
                  prefilledData={prefilledData}
                  setShowAutocompleteprimary={setShowAutocompleteprimary}
                  setShowAutocomplete={setShowAutocomplete}
                  ResponseDatanew={ResponseDatanew}
                  ResponseData={ResponseData}
                  ShowAutocompleteprimary={ShowAutocompleteprimary}
                  handlesearch={handlesearch}
                  handelselectdata={handelselectdata}
                  ShowAutocomplete={ShowAutocomplete}
                  handelselectjobtitle={handelselectjobtitle}
                  jobtitlesearch={jobtitlesearch}
                  ResponseJobData={ResponseJobData}
                  handlesave={handlesave}
                  tableShowResult={tableShowResult}
                  decisionMakerData={decisionMakerData}
                  setDecisionMakerData={setDecisionMakerData}
                  setTableShowResult={setTableShowResult}
                  handleModelSave={handleModelSave}
                  toggleResult={toggleResult}
                  isFilterRetrieve={isFilterRetrieve}
                  setResultRetrieve={setResultRetrieve}
                  isMobile={isMobile}
                  handleModelUpdate={handleModelUpdate}
                  isTabletPortrait={isTabletPortrait}
                />
              </div>
        ) : (
          <div className="child-section-of-everypage set-tabs-ai-section">
            <NewAIProfileButton
              prefilledData={prefilledData}
              validations={validations}
              handlesave={handlesave}
              handleModelSave={handleModelSave}
              decisionMakerData={decisionMakerData}
              setDecisionMakerData={setDecisionMakerData}
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              handleModelUpdate={handleModelUpdate}
            />
            <div className="details-table-form-page">
              <div className="details-table-page">
                <DetailsTableProspect
                  showingResult={showingResult}
                  newShowingResult={newShowingResult}
                  prefilledData={prefilledData}
                  setTableShowResult={tableShowResult}
                  tableShowResult={tableShowResult}
                  handleModelSave={handleModelSave}
                  applyPeopleFilterData={applyPeopleFilterData}
                  resultRetrieve={resultRetrieve}
                  fetchMoreData={fetchMoreData}
                  hasMore={hasMore}
                  totalPages={totalPages}
                  skip={skip}
                  setSkip={setSkip}
                  totalCount={totalCount}
                />
              </div>
              <div className="details-form-page">
                <DetailsFormProspect
                  prefilledData={prefilledData}
                  setShowAutocompleteprimary={setShowAutocompleteprimary}
                  setShowAutocomplete={setShowAutocomplete}
                  ResponseDatanew={ResponseDatanew}
                  ResponseData={ResponseData}
                  ShowAutocompleteprimary={ShowAutocompleteprimary}
                  handlesearch={handlesearch}
                  handelselectdata={handelselectdata}
                  ShowAutocomplete={ShowAutocomplete}
                  handelselectjobtitle={handelselectjobtitle}
                  jobtitlesearch={jobtitlesearch}
                  ResponseJobData={ResponseJobData}
                  handlesave={handlesave}
                  tableShowResult={tableShowResult}
                  decisionMakerData={decisionMakerData}
                  setDecisionMakerData={setDecisionMakerData}
                  setTableShowResult={setTableShowResult}
                  handleModelSave={handleModelSave}
                  toggleResult={toggleResult}
                  isFilterRetrieve={isFilterRetrieve}
                  setResultRetrieve={setResultRetrieve}
                />
              </div>
            </div>
          </div>
        )}
      </Layout>
    </>
  );
};
export default ProspectProfile;
